import { useEffect, useState } from "react";
import { API_BASE_URL } from "../config/api";
import { getDetails } from "../api/frontApi";

export function useProductDetails(id, product) {
  const [description, setDescription] = useState(null);
  const [mainImage, setMainImage] = useState("");
  const [loading, setLoading] = useState(!product);
  const [medias, setMedias] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!product?.id) return;

    const getMediasAndDescription = async () => {
      try {
        const response = await getDetails(product.id);

        const sortedMedias = [...response.medias].sort((a, b) => {
          if (a.type === "image" && b.type !== "image") return -1;
          if (a.type !== "image" && b.type === "image") return 1;
          return 0;
        });

        setDescription(response.description);
        setMedias(sortedMedias);

        const coverImage = response.medias.find(
          (el) => el.isCoverImage
        );

        if (coverImage) {
          setMainImage(`${API_BASE_URL}/${coverImage.path}`);
        }

        setLoading(false);
      } catch (error) {
        console.error("Erreur récupération produit:", error);
        setLoading(false);
      }
    };

    getMediasAndDescription();
  }, [product?.id]);

  const findNextImageIndex = (startIndex, direction) => {
    const sortedMedias = [...medias].sort((a, b) => {
      if (a.type === "image" && b.type !== "image") return -1;
      if (a.type !== "image" && b.type === "image") return 1;
      return 0;
    });

    let nextIndex = startIndex + direction;
    let count = 0;

    while (count < sortedMedias.length) {
      if (nextIndex >= sortedMedias.length) nextIndex = 0;
      if (nextIndex < 0) nextIndex = sortedMedias.length - 1;

      if (sortedMedias[nextIndex]?.type === "image") {
        return nextIndex;
      }

      nextIndex += direction;
      count++;
    }

    return startIndex;
  };

  const nextImage = () => {
    const nextIndex = findNextImageIndex(currentIndex, 1);

    if (medias[nextIndex]?.type === "image") {
      setCurrentIndex(nextIndex);
      setMainImage(`${API_BASE_URL}/${medias[nextIndex].path}`);
    }
  };

  const prevImage = () => {
    const prevIndex = findNextImageIndex(currentIndex, -1);

    if (medias[prevIndex]?.type === "image") {
      setCurrentIndex(prevIndex);
      setMainImage(`${API_BASE_URL}/${medias[prevIndex].path}`);
    }
  };

  const handleThumbnailClick = (index) => {
    const media = medias[index];

    if (media.type === "video" || media.type === "musique") {
      window.open(media.path, "_blank");
      return;
    }

    setCurrentIndex(index);
    setMainImage(`${API_BASE_URL}/${medias[index].path}`);
  };

  return {
    description,
    mainImage,
    loading,
    medias,
    currentIndex,
    nextImage,
    prevImage,
    handleThumbnailClick,
   
  };
}
